let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("aejs4")).then(() => parcelRequire('jCiEu'));